// Game calendar. state.day = integer days since 1859-01-01 (UTC, proleptic Gregorian).

const EPOCH = Date.UTC(1859, 0, 1);
const MS_PER_DAY = 86400000;
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// Memoized (hot: called many times per tick, mostly for today). Returns a shared frozen object — read only.
const D2D = new Map();
export function dayToDate(day) {
  let v = D2D.get(day);
  if (v === undefined) {
    if (D2D.size > 4096) D2D.clear();
    const d = new Date(EPOCH + day * MS_PER_DAY);
    v = Object.freeze({ year: d.getUTCFullYear(), month: d.getUTCMonth() + 1, dom: d.getUTCDate(), weekday: d.getUTCDay() });
    D2D.set(day, v);
  }
  return v;
}

export function dateToDay(year, month = 1, dom = 1) {
  return Math.round((Date.UTC(year, month - 1, dom) - EPOCH) / MS_PER_DAY);
}

// Fractional year, e.g. 1861.5 mid-1861. Used for interpolating annual series.
const YF = new Map();
export function yearFrac(day) {
  let v = YF.get(day);
  if (v === undefined) {
    if (YF.size > 4096) YF.clear();
    YF.set(day, (v = yearFracRaw(day)));
  }
  return v;
}
function yearFracRaw(day) {
  const { year } = dayToDate(day);
  const start = dateToDay(year);
  const len = dateToDay(year + 1) - start;
  return year + (day - start) / len;
}

export function formatDate(day) {
  const { year, month, dom } = dayToDate(day);
  return `${dom} ${MONTHS[month - 1]} ${year}`;
}

export const isFirstOfMonth = (day) => dayToDate(day).dom === 1;
export const isFirstOfQuarter = (day) => { const d = dayToDate(day); return d.dom === 1 && (d.month - 1) % 3 === 0; };

// Days-per-real-second for each speed setting (index = state.speed).
export const SPEEDS = [0, 1, 3, 10, 30];
